export const QuestionItemType = {
  Body: "body",
  Answer: "answer",
};
